import React from "react";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import FormTextField from "../../fields/textField";
import DynamicFieldLabel from "./DynamicFieldLabel";

/**
 * @name SingleLineTextFieldWrapper
 * @interface DynamicFieldConfigType
 * @param props
 * @constructor
 */
export default function SingleLineTextFieldWrapper(props: DynamicFieldConfigType) {
  return (
    <React.Fragment>
      <FormTextField
        name={props.schemaObj.id}
        label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
        disabled={props.schemaObj.disabled}
        required={props.schemaObj.mandatory}
        validate={props.validationFn}
        placeholder={props.schemaObj.placeholderLabel}
        conflictValue={props.schemaObj.conflictValue}
        fullWidth={props.schemaObj.fullWidthView}
        indented={props.schemaObj.indented}
      />
    </React.Fragment>
  );
}
